export const EVENT_STATUS = {
  BEFORE_EVENT: "beforeEvent",
  DURING_EVENT: "duringEvent",
  EVENT_ENDED: "eventEnded",
} as const;
